import { Menu } from 'lucide-react';
import { UserMenu } from './UserMenu';
import { DarkModeToggle } from './DarkModeToggle';

interface HeaderProps {
  /** Opens the mobile navigation drawer (Sidebar). */
  onOpenMobileNav: () => void;
}

/**
 * Slim top bar that sits above the page content, beside the Sidebar.
 * Left: mobile menu button · Right: theme + user.
 * Primary navigation now lives in the Sidebar.
 */
export const Header = ({ onOpenMobileNav }: HeaderProps) => {
  return (
    <header className="sticky top-0 z-30 flex items-center justify-between h-14 px-3 sm:px-4 lg:px-6 bg-white/80 dark:bg-gray-900/80 backdrop-blur border-b border-gray-200 dark:border-gray-700">
      <div className="flex items-center gap-2 sm:gap-3">
        <button
          onClick={onOpenMobileNav}
          className="md:hidden p-1.5 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          aria-label="Open menu"
        >
          <Menu className="h-5 w-5" />
        </button>
      </div>

      <div className="flex items-center gap-1.5 sm:gap-2 md:gap-3">
        <DarkModeToggle />
        <UserMenu />
      </div>
    </header>
  );
};

export default Header;
